import { Col, Row, RowProps, Space, Spin } from "antd";
import { FC } from "react";
import { Trans } from "react-i18next";
import { PositionDataButtons } from "./PositionDataButtons";
import { PositionDataMatrix } from "./PositionDataMatrix";
import { PositionDataHelper } from "./use-position-data-helper";

export interface PositionDataRowParams extends PositionDataHelper {
  // --- management data ---
  // layout
  gutterSize: RowProps["gutter"];
  // translation
  tNS: string;
  tPrefix: string;
}

export const PositionDataRow: FC<PositionDataRowParams> = ({ gutterSize, tNS, tPrefix, matrix4x3, isGettingPositionData, ...buttonComponentProps }) => {
  return (
    <Row gutter={gutterSize}>
      <Col span={5} flex="200px">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Trans ns={tNS} i18nKey={tPrefix + "fieldLabel.positionData"}/>
          <PositionDataButtons tNS={tNS} tPrefix={tPrefix} {...buttonComponentProps}/>
        </Space>
      </Col>
      <Col span={1} flex="40px"/>
      <Col span={17} flex="600px">
        <Spin spinning={isGettingPositionData}>
          <PositionDataMatrix data={matrix4x3}/>
        </Spin>
      </Col>
    </Row>
  );
};
